import { Injectable } from '@angular/core';
import { IbexSnackbarComponent } from '../../components/ibex-snackbar/ibex-snackbar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {
  private snackbarComponent!: IbexSnackbarComponent;

  register(snackbar: IbexSnackbarComponent) {
    this.snackbarComponent = snackbar;
  }

  open(message: string, duration = 3000) {
    this.snackbarComponent?.show(message, duration);
  }

  success(message: string, duration = 3000) {
    this.snackbarComponent?.show(message, duration, 'success');
  }

  warn(message: string, duration = 3000) {
    this.snackbarComponent?.show(message, duration, 'warn');
  }

  error(message: string, duration = 3000) {
    this.snackbarComponent?.show(message, duration, 'error');
  }
}
